export const SEARCHBOX_PREPROCESSORS = {
  FirstLetterInUpperCase: (value: string): string =>
    value?.length
      ? value[0].toUpperCase() + value.slice(1)
      : value
};
